import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasourceFeaturesState from './datasourceFeatures';
import updateDatasourceSettingsState from './datasourceSettings';
import updateDatasourceTypesState from './datasourceTypes';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDatasourceFeaturesState,
  ...updateDatasourceSettingsState,
  ...updateDatasourceTypesState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
